module.exports = __webpack_public_path__ + "img/floppy-disk-solid.d77c898d.svg";